import { z } from 'zod'

export const inviteOrganizationUserFormSchema = z.object({
  firstName: z
    .string()
    .min(
      1,
      'organizationUsers:inviteUserDialog.fields.firstName.errors.required'
    ),
  lastName: z.string(),
  email: z
    .string()
    .email('organizationUsers:inviteUserDialog.fields.email.errors.invalid')
    .max(256),
  roleSlug: z
    .string()
    .min(
      1,
      'organizationUsers:inviteUserDialog.fields.roleSlug.errors.required'
    ),
})

export type InviteOrganizationUserFormData = z.infer<
  typeof inviteOrganizationUserFormSchema
>
